import React from "react";
import { List, CreateButton } from "@refinedev/mui";

import { DataGrid } from "@shared/components/DataGrid";
import { CsvExportButton } from "@shared/components";
import { CreateBookMonthModal, EditBookMonthModal } from "@modules/bookMonths/components";

import { useBookMonthList } from "./controller";
import { useBookMonthListColumns } from "./columns";

export const BookMonthList = React.memo(() => {
  const {
    rows,
    loading,
    tableProps,
    selectedRows,
    dataToExport,
    createModalRef,
    editModalRef,
    setSelectedRows,
    refetch,
    translate,
  } = useBookMonthList();

  const columns = useBookMonthListColumns(refetch, translate, editModalRef);

  return (
    <>
      <List
        headerButtons={
          <>
            <CsvExportButton
              data={dataToExport}
              filename="book-months.csv"
              isDisabled={loading || !rows}
            />
            <CreateButton onClick={() => createModalRef.current?.open()} />
          </>
        }
      >
        <DataGrid
          {...tableProps}
          rows={rows}
          columns={columns}
          loading={loading}
          checkboxSelection
          rowSelectionModel={selectedRows}
          onRowSelectionModelChange={(selectionModel) =>
            setSelectedRows(selectionModel as number[])
          }
        />
      </List>

      <CreateBookMonthModal modalRef={createModalRef} onComplete={refetch} />
      <EditBookMonthModal modalRef={editModalRef} onComplete={refetch} />
    </>
  );
});
